// Production data path (IMPLEMENTATION §1.4 "data/loader.ts"): the precompiled integer defs plus the raw
// presentation JSON. No zod and no compiler in the bundle; the data tests prove these files validate and
// that simdefs.json == compile(raw).
import simdefs from '../../../shared/compiled/simdefs.json' with { type: 'json' };
import copy from '../../../shared/data/copy.json' with { type: 'json' };
import juice from '../../../shared/data/juice.json' with { type: 'json' };
import palette from '../../../shared/data/palette.json' with { type: 'json' };
import sfx from '../../../shared/data/sfx.json' with { type: 'json' };
import stalls from '../../../shared/data/stalls.json' with { type: 'json' };
import ui from '../../../shared/data/ui.json' with { type: 'json' };
import type { SimDefs } from '../sim/defs.ts';
import type { GameData } from './gameData.ts';
import type { CopyData, JuiceData, PaletteData, SfxData, StallsData, UiData } from './schema.ts';

// DEV only: this module also imports shared/data files, so it must be an HMR boundary too; otherwise a JSON
// edit would bubble up to main.ts and reload the page instead of going through loaderDev.ts's hot path.
if (import.meta.hot) import.meta.hot.accept();

export function compiledGameData(): GameData {
  return {
    sim: simdefs as unknown as SimDefs,
    ui: ui as unknown as UiData,
    juice: juice as unknown as JuiceData,
    palette: palette as unknown as PaletteData,
    stalls: stalls as unknown as StallsData,
    sfx: sfx as unknown as SfxData,
    copy: copy as unknown as CopyData,
  };
}
